import * as api from '../api/sale';
import { makeApiActionCreatorV3 } from '@actions/utils';

const namespace = 'APPRAISAL/SALE';

export const SALES_FETCH_START = `${namespace}/SALES_FETCH_START`;
export const SALES_FETCH_SUCCESS = `${namespace}/SALES_FETCH_SUCCESS`;
export const SALES_FETCH_ERROR = `${namespace}/SALES_FETCH_ERROR`;

export const fetchPropertySales = makeApiActionCreatorV3(
  api.fetchPropertySales,
  SALES_FETCH_START,
  SALES_FETCH_SUCCESS,
  SALES_FETCH_ERROR,
);

export const SALE_DELETE_START = `${namespace}/SALE_DELETE_START`;
export const SALE_DELETE_SUCCESS = `${namespace}/SALE_DELETE_SUCCESS`;
export const SALE_DELETE_ERROR = `${namespace}/SALE_DELETE_ERROR`;

export const deletePropertySale = makeApiActionCreatorV3(
  api.deletePropertySale,
  SALE_DELETE_START,
  SALE_DELETE_SUCCESS,
  SALE_DELETE_ERROR,
);

export const SALE_FETCH_START = `${namespace}/SALE_FETCH_START`;
export const SALE_FETCH_SUCCESS = `${namespace}/SALE_FETCH_SUCCESS`;
export const SALE_FETCH_ERROR = `${namespace}/SALE_FETCH_ERROR`;

export const fetchSale = makeApiActionCreatorV3(
  api.fetchSale,
  SALE_FETCH_START,
  SALE_FETCH_SUCCESS,
  SALE_FETCH_ERROR,
);

export const SALE_CODES_FETCH_START = `${namespace}/SALE_CODES_FETCH_START`;
export const SALE_CODES_FETCH_SUCCESS = `${namespace}/SALE_CODES_FETCH_SUCCESS`;
export const SALE_CODES_FETCH_ERROR = `${namespace}/SALE_CODES_FETCH_ERROR`;

export const fetchSaleCodes = makeApiActionCreatorV3(
  api.fetchSaleCodes,
  SALE_CODES_FETCH_START,
  SALE_CODES_FETCH_SUCCESS,
  SALE_CODES_FETCH_ERROR,
);

export const SALE_CREATE_START = `${namespace}/SALE_CREATE_START`;
export const SALE_CREATE_SUCCESS = `${namespace}/SALE_CREATE_SUCCESS`;
export const SALE_CREATE_ERROR = `${namespace}/SALE_CREATE_ERROR`;

export const createPropertySale = makeApiActionCreatorV3(
  api.createPropertySale,
  SALE_CREATE_START,
  SALE_CREATE_SUCCESS,
  SALE_CREATE_ERROR,
);

export const SALE_UPDATE_START = `${namespace}/SALE_UPDATE_START`;
export const SALE_UPDATE_SUCCESS = `${namespace}/SALE_UPDATE_SUCCESS`;
export const SALE_UPDATE_ERROR = `${namespace}/SALE_UPDATE_ERROR`;

export const updatePropertySale = makeApiActionCreatorV3(
  api.updatePropertySale,
  SALE_UPDATE_START,
  SALE_UPDATE_SUCCESS,
  SALE_UPDATE_ERROR,
);

export const SALE_PROPERTY_CREATE_START = `${namespace}/SALE_PROPERTY_CREATE_START`;
export const SALE_PROPERTY_CREATE_SUCCESS = `${namespace}/SALE_PROPERTY_CREATE_SUCCESS`;
export const SALE_PROPERTY_CREATE_ERROR = `${namespace}/SALE_PROPERTY_CREATE_ERROR`;

export const createSaleProperty = makeApiActionCreatorV3(
  api.createSaleProperty,
  SALE_PROPERTY_CREATE_START,
  SALE_PROPERTY_CREATE_SUCCESS,
  SALE_PROPERTY_CREATE_ERROR,
);

export const SALE_PROPERTIES_FETCH_START = `${namespace}/SALE_PROPERTIES_FETCH_START`;
export const SALE_PROPERTIES_FETCH_SUCCESS = `${namespace}/SALE_PROPERTIES_FETCH_SUCCESS`;
export const SALE_PROPERTIES_FETCH_ERROR = `${namespace}/SALE_PROPERTIES_FETCH_ERROR`;

export const fetchSaleProperties = makeApiActionCreatorV3(
  api.fetchSaleProperties,
  SALE_PROPERTIES_FETCH_START,
  SALE_PROPERTIES_FETCH_SUCCESS,
  SALE_PROPERTIES_FETCH_ERROR,
);

export const SALE_PROPERTY_DELETE_START = `${namespace}/SALE_PROPERTY_DELETE_START`;
export const SALE_PROPERTY_DELETE_SUCCESS = `${namespace}/SALE_PROPERTY_DELETE_SUCCESS`;
export const SALE_PROPERTY_DELETE_ERROR = `${namespace}/SALE_PROPERTY_DELETE_ERROR`;

export const deleteSaleProperty = makeApiActionCreatorV3(
  api.deleteSaleProperty,
  SALE_PROPERTY_DELETE_START,
  SALE_PROPERTY_DELETE_SUCCESS,
  SALE_PROPERTY_DELETE_ERROR,
);

export const FILES_FETCH_START = `${namespace}/FILES_FETCH_START`;
export const FILES_FETCH_SUCCESS = `${namespace}/FILES_FETCH_SUCCESS`;
export const FILES_FETCH_ERROR = `${namespace}/FILES_FETCH_ERROR`;

export const fetchFiles = makeApiActionCreatorV3(
  api.fetchFiles,
  FILES_FETCH_START,
  FILES_FETCH_SUCCESS,
  FILES_FETCH_ERROR,
);

export const FILE_CREATE_START = `${namespace}/FILE_CREATE_START`;
export const FILE_CREATE_SUCCESS = `${namespace}/FILE_CREATE_SUCCESS`;
export const FILE_CREATE_ERROR = `${namespace}/FILE_CREATE_ERROR`;

export const createFile = makeApiActionCreatorV3(
  api.createFile,
  FILE_CREATE_START,
  FILE_CREATE_SUCCESS,
  FILE_CREATE_ERROR,
);

export const FILE_UPDATE_START = `${namespace}/FILE_UPDATE_START`;
export const FILE_UPDATE_SUCCESS = `${namespace}/FILE_UPDATE_SUCCESS`;
export const FILE_UPDATE_ERROR = `${namespace}/FILE_UPDATE_ERROR`;

export const updateFile = makeApiActionCreatorV3(
  api.updateFile,
  FILE_UPDATE_START,
  FILE_UPDATE_SUCCESS,
  FILE_UPDATE_ERROR,
);

export const FILE_DELETE_START = `${namespace}/FILE_DELETE_START`;
export const FILE_DELETE_SUCCESS = `${namespace}/FILE_DELETE_SUCCESS`;
export const FILE_DELETE_ERROR = `${namespace}/FILE_DELETE_ERROR`;

export const deleteFile = makeApiActionCreatorV3(
  api.deleteFile,
  FILE_DELETE_START,
  FILE_DELETE_SUCCESS,
  FILE_DELETE_ERROR,
);

export const FILE_GET_START = `${namespace}/FILE_GET_START`;
export const FILE_GET_SUCCESS = `${namespace}/FILE_GET_SUCCESS`;
export const FILE_GET_ERROR = `${namespace}/FILE_GET_ERROR`;

export const getFile = makeApiActionCreatorV3(
  api.getFile,
  FILE_GET_START,
  FILE_GET_SUCCESS,
  FILE_GET_ERROR,
);

export const SET_SALE_DEED_START = `${namespace}/SET_SALE_DEED_START`;
export const SET_SALE_DEED_SUCCESS = `${namespace}/SET_SALE_DEED_SUCCESS`;
export const SET_SALE_DEED_ERROR = `${namespace}/SET_SALE_DEED_ERROR`;

export const setSaleDeed = makeApiActionCreatorV3(
  api.setSaleDeed,
  SET_SALE_DEED_START,
  SET_SALE_DEED_SUCCESS,
  SET_SALE_DEED_ERROR,
);

export const REMOVE_SALE_DEED_START = `${namespace}/REMOVE_SALE_DEED_START`;
export const REMOVE_SALE_DEED_SUCCESS = `${namespace}/REMOVE_SALE_DEED_SUCCESS`;
export const REMOVE_SALE_DEED_ERROR = `${namespace}/REMOVE_SALE_DEED_ERROR`;

export const removeSaleDeed = makeApiActionCreatorV3(
  api.removeSaleDeed,
  REMOVE_SALE_DEED_START,
  REMOVE_SALE_DEED_SUCCESS,
  REMOVE_SALE_DEED_ERROR,
);

export const POPULATE_SALE_START = `${namespace}/POPULATE_SALE_START`;
export const POPULATE_SALE_SUCCESS = `${namespace}/POPULATE_SALE_SUCCESS`;
export const POPULATE_SALE_ERROR = `${namespace}/POPULATE_SALE_ERROR`;

export const populateSaleFromDeed = makeApiActionCreatorV3(
  api.populateSaleFromDeed,
  POPULATE_SALE_START,
  POPULATE_SALE_SUCCESS,
  POPULATE_SALE_ERROR,
);

export const RESET_SALE = `${namespace}/RESET_SALE`;

export const resetSale = () => ({
  type: RESET_SALE,
});

export const SET_CURRENT_SALE = `${namespace}/SET_CURRENT_SALE`;

export const setCurrentSale = payload => ({
  type: SET_CURRENT_SALE,
  payload,
});

export const SALE_RATIO_FETCH_START = `${namespace}/SALE_RATIO_FETCH_START`;
export const SALE_RATIO_FETCH_SUCCESS = `${namespace}/SALE_RATIO_FETCH_SUCCESS`;
export const SALE_RATIO_FETCH_ERROR = `${namespace}/SALE_RATIO_FETCH_ERROR`;

export const fetchSaleRatio = makeApiActionCreatorV3(
  api.fetchSaleRatio,
  SALE_RATIO_FETCH_START,
  SALE_RATIO_FETCH_SUCCESS,
  SALE_RATIO_FETCH_ERROR,
);

export const SALE_FINANCE_FETCH_START = `${namespace}/SALE_FINANCE_FETCH_START`;
export const SALE_FINANCE_FETCH_SUCCESS = `${namespace}/SALE_FINANCE_FETCH_SUCCESS`;
export const SALE_FINANCE_FETCH_ERROR = `${namespace}/SALE_FINANCE_FETCH_ERROR`;

export const fetchSaleFinance = makeApiActionCreatorV3(
  api.fetchSaleFinance,
  SALE_FINANCE_FETCH_START,
  SALE_FINANCE_FETCH_SUCCESS,
  SALE_FINANCE_FETCH_ERROR,
);

export const SALE_FINANCE_UPDATE_START = `${namespace}/SALE_FINANCE_UPDATE_START`;
export const SALE_FINANCE_UPDATE_SUCCESS = `${namespace}/SALE_FINANCE_UPDATE_SUCCESS`;
export const SALE_FINANCE_UPDATE_ERROR = `${namespace}/SALE_FINANCE_UPDATE_ERROR`;

export const updateSaleFinance = makeApiActionCreatorV3(
  api.updateSaleFinance,
  SALE_FINANCE_UPDATE_START,
  SALE_FINANCE_UPDATE_SUCCESS,
  SALE_FINANCE_UPDATE_ERROR,
);

export const SALE_REPORT_FETCH_START = `${namespace}/SALE_REPORT_FETCH_START`;
export const SALE_REPORT_FETCH_SUCCESS = `${namespace}/SALE_REPORT_FETCH_SUCCESS`;
export const SALE_REPORT_FETCH_ERROR = `${namespace}/SALE_REPORT_FETCH_ERROR`;

export const fetchSaleReport = makeApiActionCreatorV3(
  api.fetchSaleReport,
  SALE_REPORT_FETCH_START,
  SALE_REPORT_FETCH_SUCCESS,
  SALE_REPORT_FETCH_ERROR,
);

export const SALE_REPORT_UPDATE_START = `${namespace}/SALE_REPORT_UPDATE_START`;
export const SALE_REPORT_UPDATE_SUCCESS = `${namespace}/SALE_REPORT_UPDATE_SUCCESS`;
export const SALE_REPORT_UPDATE_ERROR = `${namespace}/SALE_REPORT_UPDATE_ERROR`;

export const updateSaleReport = makeApiActionCreatorV3(
  api.updateSaleReport,
  SALE_REPORT_UPDATE_START,
  SALE_REPORT_UPDATE_SUCCESS,
  SALE_REPORT_UPDATE_ERROR,
);

export const TAXING_UNITS_UI_FETCH_START = `${namespace}/TAXING_UNITS_UI_FETCH_START`;
export const TAXING_UNITS_UI_FETCH_SUCCESS = `${namespace}/TAXING_UNITS_UI_FETCH_SUCCESS`;
export const TAXING_UNITS_UI_FETCH_ERROR = `${namespace}/TAXING_UNITS_UI_FETCH_ERROR`;

export const fetchTaxingUnitsUI = makeApiActionCreatorV3(
  api.fetchTaxingUnitsUI,
  TAXING_UNITS_UI_FETCH_START,
  TAXING_UNITS_UI_FETCH_SUCCESS,
  TAXING_UNITS_UI_FETCH_ERROR,
);

export const SALE_CHARACTERISTICS_FETCH_START = `${namespace}/SALE_CHARACTERISTICS_FETCH_START`;
export const SALE_CHARACTERISTICS_FETCH_SUCCESS = `${namespace}/SALE_CHARACTERISTICS_FETCH_SUCCESS`;
export const SALE_CHARACTERISTICS_FETCH_ERROR = `${namespace}/SALE_CHARACTERISTICS_FETCH_ERROR`;

export const fetchSaleCharacteristics = makeApiActionCreatorV3(
  api.fetchSaleCharacteristics,
  SALE_CHARACTERISTICS_FETCH_START,
  SALE_CHARACTERISTICS_FETCH_SUCCESS,
  SALE_CHARACTERISTICS_FETCH_ERROR,
);

export const SALE_CHARACTERISTICS_UPDATE_START = `${namespace}/SALE_REPORT_UPDATE_START`;
export const SALE_CHARACTERISTICS_UPDATE_SUCCESS = `${namespace}/SALE_CHARACTERISTICS_UPDATE_SUCCESS`;
export const SALE_CHARACTERISTICS_UPDATE_ERROR = `${namespace}/SALE_CHARACTERISTICS_UPDATE_ERROR`;

export const updateSaleCharacteristics = makeApiActionCreatorV3(
  api.updateSaleCharacteristics,
  SALE_REPORT_UPDATE_START,
  SALE_CHARACTERISTICS_UPDATE_SUCCESS,
  SALE_CHARACTERISTICS_UPDATE_ERROR,
);

// sale search
export const SALE_SEARCH_CONFIG_FETCH_START = `${namespace}/SALE_SEARCH_CONFIG_FETCH_START`;
export const SALE_SEARCH_CONFIG_FETCH_SUCCESS = `${namespace}/SALE_SEARCH_CONFIG_FETCH_SUCCESS`;
export const SALE_SEARCH_CONFIG_FETCH_ERROR = `${namespace}/SALE_SEARCH_CONFIG_FETCH_ERROR`;

export const fetchSaleSearchConfig = makeApiActionCreatorV3(
  api.fetchSaleSearchConfig,
  SALE_SEARCH_CONFIG_FETCH_START,
  SALE_SEARCH_CONFIG_FETCH_SUCCESS,
  SALE_SEARCH_CONFIG_FETCH_ERROR,
);

export const SEARCH_CONFIG_RESULTS_FETCH_START = `${namespace}/SEARCH_CONFIG_RESULTS_FETCH_START`;
export const SEARCH_CONFIG_RESULTS_FETCH_SUCCESS = `${namespace}/SEARCH_CONFIG_RESULTS_FETCH_SUCCESS`;
export const SEARCH_CONFIG_RESULTS_FETCH_ERROR = `${namespace}/SEARCH_CONFIG_RESULTS_FETCH_ERROR`;

export const fetchSearchConfigResults = makeApiActionCreatorV3(
  api.fetchSearchConfigResults,
  SEARCH_CONFIG_RESULTS_FETCH_START,
  SEARCH_CONFIG_RESULTS_FETCH_SUCCESS,
  SEARCH_CONFIG_RESULTS_FETCH_ERROR,
);

export const SALES_SEARCH_STANDALONE_START = `${namespace}/SALES_SEARCH_STANDALONE_START`;
export const SALES_SEARCH_STANDALONE_SUCCESS = `${namespace}/SALES_SEARCH_STANDALONE_SUCCESS`;
export const SALES_SEARCH_STANDALONE_ERROR = `${namespace}/SALES_SEARCH_STANDALONE_ERROR`;

export const searchSalesStandalone = makeApiActionCreatorV3(
  api.searchSales,
  SALES_SEARCH_STANDALONE_START,
  SALES_SEARCH_STANDALONE_SUCCESS,
  SALES_SEARCH_STANDALONE_ERROR,
);

export const SALES_SEARCH_START = `${namespace}/SALES_SEARCH_START`;
export const SALES_SEARCH_SUCCESS = `${namespace}/SALES_SEARCH_SUCCESS`;
export const SALES_SEARCH_ERROR = `${namespace}/SALES_SEARCH_ERROR`;

export const searchSales = makeApiActionCreatorV3(
  api.searchSales,
  SALES_SEARCH_START,
  SALES_SEARCH_SUCCESS,
  SALES_SEARCH_ERROR,
);

export const SALE_SEARCH_PARAMS_FETCH_START = `${namespace}/SALE_SEARCH_PARAMS_FETCH_START`;
export const SALE_SEARCH_PARAMS_FETCH_SUCCESS = `${namespace}/SALE_SEARCH_PARAMS_FETCH_SUCCESS`;
export const SALE_SEARCH_PARAMS_FETCH_ERROR = `${namespace}/SALE_SEARCH_PARAMS_FETCH_ERROR`;

export const fetchSaleSearchParams = makeApiActionCreatorV3(
  api.fetchSaleSearchParams,
  SALE_SEARCH_PARAMS_FETCH_START,
  SALE_SEARCH_PARAMS_FETCH_SUCCESS,
  SALE_SEARCH_PARAMS_FETCH_ERROR,
);

export const SALE_SEARCH_PARAM_FETCH_START = `${namespace}/SALE_SEARCH_PARAM_FETCH_START`;
export const SALE_SEARCH_PARAM_FETCH_SUCCESS = `${namespace}/SALE_SEARCH_PARAM_FETCH_SUCCESS`;
export const SALE_SEARCH_PARAM_FETCH_ERROR = `${namespace}/SALE_SEARCH_PARAM_FETCH_ERROR`;

export const fetchSaleSearchParam = makeApiActionCreatorV3(
  api.fetchSaleSearchParam,
  SALE_SEARCH_PARAM_FETCH_START,
  SALE_SEARCH_PARAM_FETCH_SUCCESS,
  SALE_SEARCH_PARAM_FETCH_ERROR,
);

export const SALE_SEARCH_PARAM_INSERT_START = `${namespace}/SALE_SEARCH_PARAM_INSERT_START`;
export const SALE_SEARCH_PARAM_INSERT_SUCCESS = `${namespace}/SALE_SEARCH_PARAM_INSERT_SUCCESS`;
export const SALE_SEARCH_PARAM_INSERT_ERROR = `${namespace}/SALE_SEARCH_PARAM_INSERT_ERROR`;

export const insertSaleSearchParam = makeApiActionCreatorV3(
  api.insertSaleSearchParam,
  SALE_SEARCH_PARAM_INSERT_START,
  SALE_SEARCH_PARAM_INSERT_SUCCESS,
  SALE_SEARCH_PARAM_INSERT_ERROR,
);

export const SALE_SEARCH_PARAM_UPDATE_START = `${namespace}/SALE_SEARCH_PARAM_UPDATE_START`;
export const SALE_SEARCH_PARAM_UPDATE_SUCCESS = `${namespace}/SALE_SEARCH_PARAM_UPDATE_SUCCESS`;
export const SALE_SEARCH_PARAM_UPDATE_ERROR = `${namespace}/SALE_SEARCH_PARAM_UPDATE_ERROR`;

export const updateSaleSearchParam = makeApiActionCreatorV3(
  api.updateSaleSearchParam,
  SALE_SEARCH_PARAM_UPDATE_START,
  SALE_SEARCH_PARAM_UPDATE_SUCCESS,
  SALE_SEARCH_PARAM_UPDATE_ERROR,
);

export const SALE_SEARCH_PARAM_DUPLICATE_START = `${namespace}/SALE_SEARCH_PARAM_DUPLICATE_START`;
export const SALE_SEARCH_PARAM_DUPLICATE_SUCCESS = `${namespace}/SALE_SEARCH_PARAM_DUPLICATE_SUCCESS`;
export const SALE_SEARCH_PARAM_DUPLICATE_ERROR = `${namespace}/SALE_SEARCH_PARAM_DUPLICATE_ERROR`;

export const duplicateSaleSearchParam = makeApiActionCreatorV3(
  api.duplicateSaleSearchParam,
  SALE_SEARCH_PARAM_DUPLICATE_START,
  SALE_SEARCH_PARAM_DUPLICATE_SUCCESS,
  SALE_SEARCH_PARAM_DUPLICATE_ERROR,
);

export const SALE_SEARCH_PARAM_DELETE_START = `${namespace}/SALE_SEARCH_PARAM_DELETE_START`;
export const SALE_SEARCH_PARAM_DELETE_SUCCESS = `${namespace}/SALE_SEARCH_PARAM_DELETE_SUCCESS`;
export const SALE_SEARCH_PARAM_DELETE_ERROR = `${namespace}/SALE_SEARCH_PARAM_DELETE_ERROR`;

export const deleteSaleSearchParam = makeApiActionCreatorV3(
  api.deleteSaleSearchParam,
  SALE_SEARCH_PARAM_DELETE_START,
  SALE_SEARCH_PARAM_DELETE_SUCCESS,
  SALE_SEARCH_PARAM_DELETE_ERROR,
);

export const SALE_TIME_CAPTURE_START = `${namespace}/SALE_TIME_CAPTURE_START`;
export const SALE_TIME_CAPTURE_SUCCESS = `${namespace}/SALE_TIME_CAPTURE_SUCCESS`;
export const SALE_TIME_CAPTURE_ERROR = `${namespace}/SALE_TIME_CAPTURE_ERROR`;

export const captureTimeOfSale = makeApiActionCreatorV3(
  api.captureTimeOfSale,
  SALE_TIME_CAPTURE_START,
  SALE_TIME_CAPTURE_SUCCESS,
  SALE_TIME_CAPTURE_ERROR,
);

export const SALE_DELETE_VERSION_START = `${namespace}/SALE_DELETE_VERSION_START`;
export const SALE_DELETE_VERSION_SUCCESS = `${namespace}/SALE_DELETE_VERSION_SUCCESS`;
export const SALE_DELETE_VERSION_ERROR = `${namespace}/SALE_DELETE_VERSION_ERROR`;

export const deleteSaleVersion = makeApiActionCreatorV3(
  api.deleteSaleVersion,
  SALE_DELETE_VERSION_START,
  SALE_DELETE_VERSION_SUCCESS,
  SALE_DELETE_VERSION_ERROR,
);

export const SALE_SEARCH_PARAM_RESET = `${namespace}/SALE_SEARCH_PARAM_RESET`;

export const resetSaleSearchParam = () => ({
  type: SALE_SEARCH_PARAM_RESET,
});

export const SALE_SEARCH_PARAM_SET = `${namespace}/SALE_SEARCH_PARAM_SET`;

export const setSaleSearchParam = searchParamID => ({
  type: SALE_SEARCH_PARAM_SET,
  searchParamID,
});

export const SET_SEARCH_FORM_DATA = `APPRAISAL/SET_SEARCH_FORM_DATA`;
export const setFormData = formData => ({
  type: SET_SEARCH_FORM_DATA,
  payload: formData,
});

export const SET_SALE_SELECTION_DATA = `APPRAISAL/SET_SALE_SELECTION_DATA`;
export const setSaleSelectionData = formData => ({
  type: SET_SALE_SELECTION_DATA,
  payload: formData,
});

export const CHANGE_PAGE = `APPRAISAL/CHANGE_PAGE`;
export const CHANGE_ROWS_PER_PAGE = `APPRAISAL/CHANGE_ROWS_PER_PAGE`;

export const changePage = page => ({
  type: CHANGE_PAGE,
  payload: page,
});

export const changeRowsPerPage = rowsPerPage => ({
  type: CHANGE_ROWS_PER_PAGE,
  payload: rowsPerPage,
});
